import React from 'react';
import Select from 'react-select';
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
} from 'reactstrap';
import { PAGE_SIZES, DEFAULT_PAGE_SIZE } from 'views/types';

type PaginationProps = {
  totalCount: number;
  pageSize?: number;
  currentPage: number;
  onPageChange: (number) => any;
  onPageSizeChange: (number) => any;
};

type PItemProps = {
  pageNumber: number;
  elementProperty?: string;
};

// TODO: refactor
const slimColourStyles = {
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white',
    paddint: '5px',
    maxHeight: '50px',
    // maxWidth: '100px',
    marginLeft: 'auto',
    cursor: 'pointer',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
      cursor: 'pointer',
    };
  },
};

const PaginationList = ({
  totalCount,
  currentPage = 1,
  pageSize = DEFAULT_PAGE_SIZE,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) => {
  const pageCount = Math.ceil(totalCount / pageSize);
  if (currentPage > pageCount) currentPage = pageCount;
  const leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;

  // calculate mid pages
  let midPages =
    currentPage > leftPages && leftPages < pageCount
      ? pageCount - leftPages
      : 0;
  if (midPages > 3) {
    midPages = 3;
    if (pageCount === currentPage) midPages = 2;
  }

  let rightPages =
    pageCount > leftPages && pageCount - currentPage - 1 > 0
      ? pageCount - currentPage - 1
      : 0;

  // console.log({
  //     msg: "pagination list.",
  //     totalCount,
  //     currentPage,
  //     pageSize,
  //     pageCount,
  //     leftPages,
  //     midPages,
  //     rightPages,
  // })

  const renderPageLinks = (start: number, end: number) => {
    const pages: any[] = [];
    for (let pageNumber = start; pageNumber <= end; pageNumber++) {
      pages.push(<PageLink pageNumber={pageNumber} key={pageNumber} />);
    }

    return pages;
  };

  if (pageCount <= 0) return <></>;

  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber);
    const element = document?.querySelector(
      'li.page-item active',
    ) as HTMLElement;
    if (element) {
      element.focus();
    }
  };

  const PageLink = ({ pageNumber, elementProperty }: PItemProps) => {
    const active = pageNumber === currentPage;
    if (active) elementProperty = 'active';

    const previous = elementProperty === 'previous';
    const next = elementProperty === 'next';
    let pageNumberText: any = previous || next ? '' : pageNumber;

    return (
      <PaginationItem active={active} key={pageNumber}>
        <PaginationLink
          previous={previous}
          next={next}
          onClick={() => handlePageChange(pageNumber)}
        >
          {pageNumberText}
        </PaginationLink>
      </PaginationItem>
    );
  };

  const MorePagesItem = () => {
    return <PaginationItem className="more-pages">...</PaginationItem>;
  };

  return (
    <Row>
      <Col sm="12" md="9" lg="10">
        <Pagination aria-label="Page navigation example">
          {/* previous link */}
          {currentPage > 1 && (
            <PageLink elementProperty="previous" pageNumber={currentPage - 1} />
          )}
          {/* left pages */}
          {leftPages > 0 && renderPageLinks(1, leftPages)}
          {/* mid pages */}
          {midPages > 1 && <MorePagesItem />}
          {midPages > 0 &&
            renderPageLinks(
              currentPage - 1,
              midPages === 2 ? currentPage : currentPage + 1,
            )}
          {/* right pages */}
          {rightPages > 1 && <MorePagesItem />}
          {rightPages > 0 &&
            currentPage < pageCount &&
            renderPageLinks(pageCount, pageCount)}
          {/* next link */}
          {pageCount > currentPage && (
            <PageLink elementProperty="next" pageNumber={currentPage + 1} />
          )}
        </Pagination>
      </Col>
      <Col sm="12" md="3" lg="2">
        <Select
          className="custom-360-dropdown"
          value={{
            label: pageSize.toString(),
            value: pageSize.toString(),
          }}
          onChange={(e) => {
            onPageSizeChange(parseInt(e ? e.value : '0'));
          }}
          styles={slimColourStyles}
          options={PAGE_SIZES}
        />
      </Col>
    </Row>
  );
};

export default PaginationList;
